import axios from 'axios'
import env from '../env'

class GuideApi {
  /** 获取功能权限 */
  getListByKeys (data: any) {
    return axios.post(`${env.CONFIGAPIINTERIOR}/listByKeys`, data).catch((err) => {
      return err
    })
  }
}

export default new GuideApi()
